<form
  #bulkEditForm="ngForm"
  id="bulkEditForm"
  name="bulkEditForm"
  class="bulk-edit-modal"
  (submit)="save()"
>
  <div class="tw-flex tw-justify-end tw-mr-[5px]">
    <button
      type="button"
      class="close"
      (click)="dismiss()"
      aria-label="Click to close this modal"
    >
      <streamline-icon name="close" width="12" height="12"></streamline-icon>
    </button>
  </div>

  <h4 class="mb-4">{{ title }}</h4>
  <mat-dialog-content class="tw-mb-[5px]">
    <div class="align-left">
      <div #target></div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions
    align="end"
    class="tw-flex-col md:!tw-flex-row tw-gap-2.5"
  >
    <button
      rv-button
      variant="secondary"
      type="button"
      class="tw-w-full md:!tw-w-fit"
      (click)="cancel()"
    >
      Cancel
    </button>
    <button
      rv-button
      type="submit"
      id="saveBulkEditForm"
      class="tw-w-full md:!tw-w-fit"
      [disabled]="bulkEditForm.invalid"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
